export default {
  form: {
    padding: 10,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  creditCard: {
    margin: 10,
    padding: 10,
  },
  creditCardProps: {
    padding: 10,
    flex: 1,
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/CreditCardDialog/styles.js